import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { formatDate } from '../utils/formatDate';
import { BiHorizontalCenter } from 'react-icons/bi';
import { PiDotsThree, PiSunHorizon } from 'react-icons/pi';
import { generatePassword } from '../utils/generatePassword';
import Pagination from '../components/Pagination';
import { toast } from 'react-toastify';
import Loader from '../components/Loader'
import Spinner from '../components/Spinner';

export default function Staff() {
  const [userData, setUserData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    role_id: '',
  });



  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
    itemsPerPage: 10,
  });

  const [users, setUsers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDeleteOpen, setModalDeleteOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [roles, setRoles] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const currentDateTime = new Date().toLocaleString();

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/api/staff?page=${currentPage}`);
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      const data = await response.json();
      setUsers(data['data']);
      setMetaData({
        totalItems: data.meta.totalItems,
        totalPages: data.meta.totalPages,
        currentPage: data.meta.currentPage,
        itemsPerPage: data.meta.itemsPerPage
      });
      console.log(data)
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (email) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/staff/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        toast.success(message);
        setError('');
      } else {
        setError(data.message || 'Something went wrong');
        toast.error(error);
        setMessage('');
      }
    } catch (err) {
      setError('An error occurred while requesting a password reset.');
    }
  }

  const statusChange = async (params) => {
    try {
      // Ensure params contains the `id` and `active` status
      const { id, active } = params;

      if (typeof active !== 'boolean') {
        throw new Error('Active status must be a boolean value');
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/staff/${id}/active-status`,
        {
          method: 'PATCH', // Correct HTTP method
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ active: !active }), // Correctly pass active in request body
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Handle success
        toast.success(data.message);
      } else {
        // Handle errors from the API
        toast.error(data.message);
        throw new Error(data.message || 'Failed to update active status');
      }
    } catch (err) {
      // Handle network or other errors
      toast.error('Error in statusChange:', err.message);

      throw new Error(err.message || 'An unexpected error occurred');
    } finally {
      fetchUsers();
    }
  };




  const fetchRoles = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/api/roles`);
      if (!response.ok) {
        throw new Error("Failed to fetch Couriers");
      }
      const data = await response.json();
      setRoles(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, [currentPage]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      if (editMode) {
        // Update existing user
        await fetch(`${apiUrl}/api/staff/${currentUserId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            role_id: userData.role_id,
          }),
        });
      } else {
        // Generate password and add it to userData
        const generatedPassword = generatePassword(10);
        userData.password = generatedPassword;

        // Create new user
        const response = await fetch(`${apiUrl}/api/staff/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            password: userData.password,
            role_id: userData.role_id,
            created_at: new Date().toISOString(),
          }),
        });

        // Check if the registration was successful
        if (response.ok) {
          // Prepare email content
          const emailContent = `
  <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Welcome New Admin</title>
</head>
<body style="font-family: Arial, Helvetica, sans-serif;">
    <div style="margin: 2%; text-align: center; color: black; border: 2px solid #e5e5e5; background: white;">
        <div>
            <img src="https://firebasestorage.googleapis.com/v0/b/ajo-warehouse.firebasestorage.app/o/meta%2FAONE%20Logistics.jpeg?alt=media&token=e2c4dfa4-a07d-41fd-8d52-8a13c5fd40a3" style="width: 100%;" alt="Welcome">
        </div>
        
        <br>
        <p style="padding: 0px 25px; text-align: left;">
            Dear ${userData.first_name} ${userData.last_name}, 
            <br><br>
             Welcome to **AJO Shipping**. Your account has been successfully created, and you now have access to our admin portal. We are excited to have you join our team in streamlining operations and delivering exceptional service.
        </p>

        <h3 style="text-align: left; padding: 0px 25px;">Your Login Details:</h3>
        <ul style="text-align: left; padding: 0px 25px; list-style-type: none;">
            <li><b>Username:</b> ${userData.email}</li>
            <li><b>Password:</b> ${userData.password}</li>
            <li><b>Portal:</b> <a href="{{portalLink}}" style="color: #1797c9; text-decoration: none;">Admin Portal</a></li>
        </ul>
        
        <p style="padding: 0px 25px; text-align: left;">
            Please keep your login credentials confidential and change your password after logging in for the first time to ensure security.
        </p>

        <p style="padding: 0px 25px; text-align: left;">
            Thank you for joining us. If you have any questions or need assistance, feel free to contact our support team.
        </p>

        <br>
        <img src="https://firebasestorage.googleapis.com/v0/b/ajo-warehouse.firebasestorage.app/o/meta%2FAONE%20Logistics.jpeg?alt=media&token=e2c4dfa4-a07d-41fd-8d52-8a13c5fd40a3" style="width: 100%;" alt="Footer">
    </div>

    <div style="margin: 5%; color: #7a7a7a; font-family: 'Times New Roman', Times, serif;">
        <i>
            Sincerely,<br><br>
            AJO Shipping. <br>
            <a href="https://islandlogishub.com" style="color: #1797c9; text-decoration: none;">www.islandlogishub.com/a><br>
            Email: <br><br>
            <img width="180px" src="https://firebasestorage.googleapis.com/v0/b/ajo-warehouse.firebasestorage.app/o/meta%2FAONE%20Logistics.jpeg?alt=media&token=e2c4dfa4-a07d-41fd-8d52-8a13c5fd40a3" alt="Footer Logo">
            <br>
            
        </i>
    </div>
</body>
</html>
          `;

          // Send email with password
          await fetch(`${apiUrl}/api/send-email`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              to: userData.email,
              subject: 'Welcome to Our Service!',
              html: emailContent,
            }),
          });
        } else {
          console.error('Registration failed, email will not be sent');
        }
      }

      fetchUsers();
      handleModalClose();
      console.log(`Data sent for user with ID: ${userData.id}`);
    } catch (error) {
      console.error('Error saving user:', error);
      setError('Error saving user. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleEdit = (id) => {
    const toEdit = users.find((usr) => usr.id === id);
    if (toEdit) {
      setUserData(toEdit);
      setCurrentUserId(id);
      setEditMode(true);
      setModalOpen(true);
    }
  };

  const handleDeleteModal = (id) => {
    const toDelete = users.find((usr) => usr.id === id);
    if (toDelete) {
      setUserData(toDelete);
      setCurrentUserId(id);
      setModalDeleteOpen(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${apiUrl}/api/staff/${id}`, {
        method: 'DELETE',
      });
      fetchUsers();
      setModalDeleteOpen(false);
    } catch (error) {
      console.error('Error deleting user:', error);
      setError('Error deleting user. Please try again.');
      setModalDeleteOpen(false);

    }
  };


  const handleModalClose = () => {
    setModalOpen(false);
    setEditMode(false);
    setCurrentUserId(null);
    setUserData({
      first_name: '',
      last_name: '',
      email: '',
      role_id: '',
    });
  };

  const handleSendEmail = async (id) => {
    const tomail = users.find((usr) => usr.id === id);
    try {
      const response = await fetch(`${apiUrl}/api/mailer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subject: 'Reset Your Password',
          text: 'just a test',
          to: tomail.email,

        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send email');
      }

      const data = await response.json();

    } catch (error) {

    }
  }


  return (
    <Layout>{loading ? <Spinner /> :
      <div className="p-4 bg-base-100 shadow-xl w-4/5 lg:w-full h-[100%] ">
        <section className="flex justify-between items-center mb-4">
          <h2 className="text-4xl font-semibold">Staff</h2>

          <button className="btn btn-error text-white" onClick={() => setModalOpen(true)}>
            Add User
          </button>
        </section>
        <section className=''>
          <table className='table-auto w-full border-collapse border border-gray-300'>
            <thead className="bg-gray-100">
              <tr>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  First Name
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  Last Name
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  Email
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  Status
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  Role
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>
                  Created at
                </th>
                <th className='border px-2 sm:px-4 py-2 text-left font-semibold'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td className="border border-gray-300">{user.first_name}</td>
                  <td className="border border-gray-300">{user.last_name}</td>
                  <td className="border border-gray-300">{user.email}</td>
                  <td className="border border-gray-300">{user.active ? "Active" : "InActive"}</td>
                  <td className="border border-gray-300">
                    {roles.find(role => role.id === user.role_id)?.name}
                  </td>
                  <td className="border border-gray-300">{formatDate(user.created_at)}</td>
                  <td className="border border-gray-300">
                    <div className="dropdown">
                      <div tabIndex={0} role="button" className="btn m-1 bg-base-300"><PiDotsThree /></div>
                      <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                        <li onClick={() => handleEdit(user.id)}><a>Edit</a></li>
                        <li onClick={() => handleDeleteModal(user.id)}><a>Delete</a></li>
                        <li onClick={() => resetPassword(user.email)}><a>Reset Passowrd</a></li>
                        <li onClick={() => statusChange(user)}><a className='text-red-500'>{user.active ? "Deactivate" : "Reactivate"}</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Pagination
          currentPage={metaData.currentPage}
          totalPages={metaData.totalPages}
          totalItems={metaData.totalItems}
          itemsPerPage={metaData.itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>}

      {modalOpen && (
        <dialog className="modal modal-open bg-gray-50">
          <form onSubmit={handleSubmit} className="modal-box">
            <h1 className="text-4xl font-bold text-black">{editMode ? 'Edit Staff' : 'Add Staff'}</h1>

            {/* First Name */}
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">First Name</span>
              </label>
              <input
                type="text"
                name="first_name"
                value={userData.first_name || ''}
                onChange={handleChange}
                className="input input-bordered w-full bg-gray-50"
                required
              />
            </div>

            {/* Last Name */}
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Last Name</span>
              </label>
              <input
                type="text"
                name="last_name"
                value={userData.last_name || ''}
                onChange={handleChange}
                className="input input-bordered w-full bg-gray-50"
                required
              />
            </div>

            {/* Email Address */}
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Email Address</span>
              </label>
              <input
                type="email"
                name="email"
                value={userData.email || ''}
                onChange={handleChange}
                className="input input-bordered w-full bg-gray-50"
                required
              />
            </div>

            {/* Role Dropdown */}
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Role</span>
              </label>
              <select
                name="role_id"
                value={userData.role_id || ''}
                onChange={handleChange}
                className="select select-bordered w-full bg-gray-50"
                required
              >
                <option value="" disabled>Select role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div className="flex gap-4 mt-4 justify-center">
              <button
                type="button"
                className="btn bg-gray-300"
                onClick={handleModalClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn bg-primary text-white"
              >
                {editMode ? 'Update' : 'Add'}
              </button>
            </div>
          </form>
        </dialog>
      )}


      {modalDeleteOpen && (
        <dialog id="delete_modal" class="modal modal-open">
          <div class="modal-box">
            <h3 class="text-lg font-bold">Delete {userData.first_name} {userData.last_name}</h3>
            <p class="py-4">Are you Sure you want to delete {userData.first_name} {userData.last_name}?</p>

            <div className='flex space-x-4 '>
              <button className='btn bg-error text-white' onClick={() => handleDelete(userData.id)} >Delete</button>
              <button className='btn' onClick={() =>
                setModalDeleteOpen(false)
              }>Close</button>
            </div>
          </div>
          <form method="dialog" class="modal-backdrop">

          </form>
        </dialog>)}
    </Layout>
  )
}
